export default __webpack_public_path__ + "static/large-network-3b3d5e99ae9405a24d09767e0235bdfc.png";